import { path, video } from 'framer-motion/client';
import { gifsPath, iconsPath, imagePath, videoPath } from './imagePath';
import { image } from 'framer-motion/m';

// export const DocumentsLinks = [
//   {
//     name: 'Platform Essentials',
//     path: '/documentation',
//     submenu: [
//       {
//         name: 'Introduction',
//         path: '/documentation/introduction',
//       },
//       {
//         name: 'Getting Started',
//         path: '/documentation/getting-started',
//       },
//       {
//         name: 'Concepts',
//         submenu: [
//           {
//             name: 'AR Technology',
//             path: '/documentation/concepts/ar',
//           },
//           {
//             name: 'VR Technology',
//             path: '/documentation/concepts/vr',
//           },
//           {
//             name: 'MR Technology',
//             path: '/documentation/concepts/mr',
//           },
//         ],
//       },
//       // {
//       //   name: 'Technologies',
//       //   path: '/documentation/technologies',
//       // },
//     ],
//   },
//   {
//     name: 'Augmented Reality',
//     path: '/documentation/augmented-reality',
//   },
//   // {
//   //   name: 'Virtual Reality',
//   //   path: '/documentation/virtual-reality',
//   // },
//   // {
//   //   name: 'Web3D',
//   //   path: '/documentation/web3d',
//   // },
//   // {
//   //   name: 'Mixed Reality',
//   //   path: '/documentation/mixed-reality',
//   // },
//   // {
//   //   name: 'Visual Editor Features',
//   //   path: '/documentation/visual-editor',
//   // },
//   // {
//   //   name: 'Artificial Intelligence',
//   //   path: '/documentation/artificial-intelligence',
//   // },
//   {
//     name: 'Analytics',
//     path: '/documentation/analytics',
//   },
//   // {
//   //   name: 'Operating System',
//   //   path: '/documentation/os',
//   // },
// ];


import { trandingTopics } from '../components/data/data/TrendingTopics/TrendingTopicsData';

export const DocumentsLinks = [
  {
    name: 'Platform Essentials',
    path: '/documentation',
    submenu: [
      { name: 'Introduction', path: '/documentation/introduction' },
      { name: 'Getting Started', path: '/documentation/getting-started' },
      {
        name: 'Concepts',
        submenu: [
          { name: 'AR Technology', path: '/documentation/concepts/ar' },
          { name: 'VR Technology', path: '/documentation/concepts/vr' },
          { name: 'MR Technology', path: '/documentation/concepts/mr' },
        ],
      },
    ],
  },
  { name: 'Augmented Reality', path: '/documentation/augmented-reality' },
  { name: 'Analytics', path: '/documentation/analytics' },
  ...trandingTopics
    .map((topic, i) => ({ topic, i })) // preserve original index
    .filter(({ topic }) => !topic.redirectTo) // filter without losing index
    .map(({ topic, i }) => ({
      name: topic.title,
      path: `/documentation/trending/${i}`,
    })),
];
export const arrayList = [
  {
    percentage: '60%',
    text: 'Reduction in error rates.',
    title: 'Training & Simulation',
    desc: 'Enhances training and operations with immersive simulations, real-time guidance, and hands-on learning.',
    video: videoPath?.simulation,
  },
  {
    percentage: '90%',
    text: 'Increase in retention rates.',
    title: 'Education Tech',
    desc: 'Enhances education with immersive learning, interactive simulations, and 3D visualization, making complex concepts easier to understand and more engaging',
    video: videoPath?.education,
    // video: videoPath?.lunar,
  },
  {
    percentage: '20%',
    text: 'Boost in conversion rates.',
    title: 'Sales & Marketing',
    desc: 'Transforms marketing with immersive product experiences, interactive storytelling, virtual try-ons, and engaging brand interactions, enhancing customer engagement and conversion..',
    video: videoPath?.cocos,
    // video: videoPath?.arPhone,
  },
  {
    percentage: '40%',
    text: 'increased user engagement',
    title: 'Gamification & Entertainment',
    desc: 'Immersive experiences, interactive storytelling, real-time engagement, and lifelike simulations, create more engaging and dynamic user experiences.',
    video: videoPath?.gamification,
    // video: videoPath?.lunar,
  },
  {
    percentage: '25%',
    text: 'Reduction in product development  time.',
    title: 'Design & Prototyping',
    desc: 'Enabling immersive 3D visualization, real-time collaboration, and rapid iterations, reducing costs and accelerating development.',
    video: videoPath?.prototype,
    // video: videoPath?.arPhone,
  },
];

export const faqs = [
  {
    question: 'What is Spatial Grid for Enterprises?',
    answer:
      'Spatial Grid for Enterprises is a platform that enhances collaboration, accelerates training, and streamlines operations through spatial computing.',
  },
  {
    question: 'How does Spatial Grid billing work?',
    answer:
      'Spatial Grid offers flexible billing plans based on usage. You can choose monthly or annual subscriptions, and pricing scales with your needs.',
  },
  {
    question: 'What kind of support does the platform offer the team?',
    answer:
      'We provide 24/7 support, including documentation, live chat, and dedicated account managers for enterprise customers.',
  },
  {
    question: 'Do you offer services based projects?',
    answer:
      "Yes, we offer custom project-based services tailored to your enterprise's specific needs. Contact us for more details.",
  },
];

// export const trandingTopics = [
//   { title: 'Using MCP(Model Context Protocol) in Spatial Grid platform' },
//   { title: 'Sharing Projects with External Users' },
//   { title: ' Publishing for Mobile(AR)/VR/MR' },
//   { title: 'VR Flow document creation ' },
//   // { title: 'Issues with confirmation code or password reset emails ' },
//   // { title: 'Sharing with users outside your team' },
// ];

export const HelpCenterLvl_2_1 = [
  {
    title: '1. Introduction to Spatial Grid  ',
    border: true,
  },
  {
    title: '2.  Understanding Spatial Grid Use Cases  ',
    border: true,
  },
  {
    title: '3. Platform Architecture & Capabilities',
    border: true,
  },

  {
    title: '4. Device & Hardware Support',
    border: true,
  },

  {
    title: '5. Creating & Managing Experiences ',
    border: true,
  },

  {
    title: '6.User Roles, Access & Governance ',
    border: true,
  },
  {
    title: '7.Analytics, Insights & Reporting',
    border: true,
  },
  {
    title: '8.Deployment, Integration & IT  ',
    border: true,
  },
  {
    title: '9.Readiness Enterprise Enablement & Support ',
    border: true,
  },
  {
    title: 'See all 9 articles',
    icon: true,
    border: false,
    color: '#EE2B2A',
    path: '/help-center/getting-started-articles',
  },
];

export const HelpCenterLvl_2_2 = [
  {
    title: "Spatial Grid's Visual Editor",
    border: true,
  },

  {
    title: 'Research and Development',
    border: true,
  },

  {
    title: 'Feature Use',
    border: true,
  },

  {
    title: 'Migrating to Enterprise Plan',
    border: true,
  },

  {
    title: 'Team management ',
    border: true,
  },

  {
    title: 'Create a new team ',
    border: false,
  },

 
];
export const MarketingSalesList = [
  { title: 'Americana' },
  { title: 'Creme21' },
  { title: 'Kellogs' },
  { title: 'Americana' },
  { title: 'Creme21' },
  { title: 'Kellogs' },
  { title: 'Americana' },
  { title: 'Creme21' },
  { title: 'Kellogs' },
];



export const array1Card = [
  {
    title: 'Innovative and Impactful Projects',
    desc: "At Spatial Grid, you'll have the opportunity to work on exciting and impactful projects that shape the digital landscape. From designing intuitive user interfaces to developing robust software solutions, you'll be part of a team that creates products that make a difference.",
  },
  {
    title: 'Supportive Environment',
    desc: "At Spatial Grid, you'll have the opportunity to work on exciting and impactful projects that shape the digital landscape. From designing intuitive user interfaces to developing robust software solutions, you'll be part of a team that creates products that make a difference.",
  },
  {
    title: 'Continuous Learning and Growth',
    desc: "We believe in investing in our team's growth and development. We provide opportunities for continuous learning, whether it's through workshops, training programs, or attending industry conferences. At SquareUp, you'll have the chance to expand your skill set and stay up-to-date with the latest trends and technologies.",
  },
  {
    title: 'Challenging and Rewarding Work',
    desc: "Our projects are challenging, but the rewards are even greater. We tackle complex problems and push ourselves to deliver innovative solutions. You'll be empowered to take ownership of your work, make a real impact, and see your ideas come to life.",
  },
];

export const xrData = [
  {
    id: 1,
    icon: imagePath?.environment,
    title: 'Dynamic environment-object',
    description: 'anchoring for real-world precision',
  },
  {
    id: 2,
    icon: imagePath?.letency,
    title: 'Low-latency',
    description: 'spatial awareness for real-time interaction',
  },
  {
    id: 3,
    icon: imagePath?.gesture,
    title: 'Gesture & gaze-',
    description: 'anchoring for real-world precision',
  },
  {
    id: 4,
    icon: imagePath?.multiUser,
    title: 'Multi-user',
    description: 'shared presence across persistent spatial sessions',
  },
];

export const gridAiData = [
  {
    id: 1,
    icon: iconsPath?.experienceGeneration,
    title: 'Prompt-to-Experience Generation',
    description:
      'Turn text, image, or video inputs into immersive scenes, simulations, or training modules.',
  },
  {
    id: 2,
    icon: iconsPath?.agenticLoop,
    title: 'Agentic Iteration Loop',
    description:
      'AI agent tests the experience, gathers insights, and continuously improves performance.',
  },
  {
    id: 3,
    icon: iconsPath?.analytics,
    title: 'Built-in Analytics for Continuous Learning',
    description:
      'Captures real-time user behavior to optimize interactions, layouts, and outcomes.',
  },
  {
    id: 4,
    icon: iconsPath?.modularBusiness,
    title: 'Modular, Business-Specific Assets',
    description:
      'Generates reusable templates and logic tailored to your enterprise needs.',
  },
];

export const researchData = [
  {
    id: 1,
    icon: iconsPath?.manufacturing,
    title: 'Smart manufacturing and Digital Twins',
  },
  {
    id: 2,
    icon: iconsPath?.enterprize,
    title: 'Enterprise Training and Simulation',
  },
  {
    id: 3,
    icon: iconsPath?.safety,
    title: 'Safety and Training in Hazardous Workspaces',
  },
  {
    id: 4,
    icon: iconsPath?.machinery,
    title: 'High Level Simulation of Machinery',
  },
  {
    id: 5,
    icon: iconsPath?.retail,
    title: 'Retail and Customer Engagement',
  },
];

export const storySections = [
  {
    id: '01',
    title: 'Design',
    description: `At Spatial Grid, design is more than aesthetics — it's a strategic foundation. We craft immersive, intuitive experiences that feel as seamless as they are stunning. Every interface, environment, and interaction is built to empower users and enhance enterprise efficiency. We design with purpose, guided by user insight, industry context, and the belief that spatial experiences should feel natural, not novel.`,
  },
  {
    id: '02',
    title: 'Engineering',
    description: `We engineer the future with precision. Our systems are built on scalable architecture, real-time spatial intelligence, and advanced agentic AI — delivering performance, security, and adaptability. Whether it's a digital twin, an XR platform, or an AI-driven experience, our engineering team ensures every pixel and process functions flawlessly across complex environments. Innovation is our engine; robust engineering is how we drive it forward.`,
  },
  {
    id: '03',
    title: 'Project Management',
    description: `Our approach to project management blends agility with accountability. We operate with transparent timelines, clear communication, and dynamic workflows — keeping momentum high and surprises low. Every deployment is guided by a dedicated team that understands the stakes, speaks your language, and adapts to your needs. At Spatial Grid, success isn't just about what we build — it's how we get you there.`,
  },
  {
    id: '04',
    title: 'Collaboration',
    description: `We don't work for you — we work with you. Spatial Grid thrives on true collaboration, where your expertise meets ours to co-create solutions that matter. We listen, iterate, and align at every stage, treating your vision as a shared mission. Across teams, time zones, and technologies, collaboration is the thread that binds innovation into impact. Together, we move further — and faster.`,
  },
  {
    id: '05',
    title: 'Client-Centric Approach',
    description: `Your challenges shape our roadmap. Our client-first philosophy means we build around your goals, your context, and your future. We take time to understand your workflows, culture, and aspirations — translating them into spatially intelligent experiences that truly deliver. With flexible deployment models, tailored solutions, and responsive support, we don't just serve clients — we empower long-term partners ready to lead in tomorrow's world.`,
  },
  {
    id: '06',
    title: 'Driving Success',
    description: `For us, success isn't just launching a product — it's elevating your enterprise. We measure impact through outcomes: increased efficiency, deeper engagement, smarter decisions. By combining immersive design, cutting-edge engineering, agile delivery, and human collaboration, we drive digital transformation that lasts. With Spatial Grid, you're not adopting tech — you're unlocking a new dimension of success, where space becomes strategy and intelligence becomes action.`,
  },
];

export const industries = [
  {
    name: 'Manufacturing & Industrial',
    icon: iconsPath.manufacturingIndustrial,
    path: '/industries/manufacturing-industrial',
  },
  {
    name: 'Healthcare and Pharma',
    icon: iconsPath.healthcare,
    path: '/industries/healthcare-pharma',
  },
  {
    name: 'Retail & E-Commerce',
    icon: iconsPath.retailEcommerce,
    path: '/industries/retail-ecommerce',
  },
  {
    name: 'Education & Training',
    icon: iconsPath.educationTraining,
    path: '/industries/education-training',
  },
  {
    name: 'Automotive & Transportation',
    icon: iconsPath.transportation,
    path: '/industries/automotive-transportation',
  },
  {
    name: 'Architecture & Real Estate',
    icon: iconsPath.realEstate,
    path: '/industries/realstate-architecture',
  },
  {
    name: 'Defense & Aerospace',
    icon: iconsPath.defence,
    path: '/industries/defence-aerospace',
  },
  { name: 'Energy and Mining', icon: iconsPath.oilGas, path: '/industries/energy-mining' },
  {
    name: 'Tourism & Hospitality',
    icon: iconsPath.tourismHospitality,
    path: '/industries/tourism-hospitality',
  },
];

export const multiplayerData = [
  {
    title: 'Shared Coordinate System ',
    description: 'Spatial grid anchors shared content for all users',
    img: imagePath?.cordinateSystem,
  },
  {
    title: 'Real-Time Position & Action Sync',
    description: 'Live sync of actions and movement across users.',
    img: imagePath?.realtimePosition,
  },
  {
    title: 'Presence Awareness & Avatars ',
    description: 'Avatars show presence, gestures, gaze, & voice.',
    img: imagePath?.awearnessAvatar,
  },
  {
    title: 'Interaction Zones within Grid Cells',
    description: 'Zones enable shared tasks & interactive spatial tools.',
    img: imagePath?.interactionZone,
  },
  {
    title: 'State Persistence & Syncing',
    description: 'User actions persist & sync across all sessions.',
    img: imagePath?.statePersistence,
  },
  {
    title: 'Voice & Gesture-Based Interaction',
    description: 'Gestures and voice enable natural communication.',
    img: imagePath?.voiceGesture,
  },
];

export const multiplayerTabFeature = [
  {
    title: 'Real-Time Position & Action Sync',
    desc: 'Player positions and actions sync via Mirror (Unity), ensuring low-latency visibility of interactions like picking objects, pointing, and annotating.',
    video: videoPath?.RealTimePosition,
  },
  {
    title: 'Presence Awareness & Avatars',
    desc: 'Each user appears as an avatar or visual cue, showing gaze, gestures, and voice indicators to enable natural, human-like communication.',
    video: videoPath?.PresenceAwarenesAvatars,
  },
  {
    title: 'Interaction Zones within Grid-Cells',
    desc: 'Each grid cell hosts collaborative zones—like whiteboarding or media playback—triggering UI changes, permissions, or tools when users enter.',
    video: videoPath?.InteractionZonesCell,
  },
];

export const analyticsData = [
  {
    title: 'Spatial Grid-Based Telemetry ',
    description:
      'Every grid cell becomes an analytical unit—capturing interactions, movement, collisions, time-in-zone, and user density.',
    img: imagePath?.spatialgridTelemetry,
  },
  {
    title: 'Interaction Heatmaps Across Grid Cells',
    description:
      'Understand where users focus, hesitate, succeed, or struggle through auto-generated heatmaps & intensity overlays.',
    img: imagePath?.interactionHeatmap,
  },
  {
    title: 'Real-Time Event & State Logging',
    description:
      'Every click, grab, trigger, teleport, gesture, or tool use is logged and timestamped for replay, audits, or performance scoring.',
    img: imagePath?.realTimeEventState,
  },
  {
    title: 'User Timeline & Journey Replay',
    description:
      'Replay user sessions in 3D—step-by-step—to analyze decisions, identify gaps, and improve both content and training efficiency.',
    img: imagePath?.userTimeLineJourney,
  },
  {
    title: 'Cross-Device Analytics Layer',
    description:
      'Unified insights across mobile AR, VR headsets, MR glasses, and desktop simulations—ensuring consistent, platform-agnostic measurement.',
    img: imagePath?.crossDeviceAnalytics,
  },
  {
    title: 'Outcome Prediction & Recommendations',
    description:
      'Predict success rates, goal conversion, or missteps using historical performance patterns across spatial grid datasets.',
    img: imagePath?.prediction,
  },
];

export const analyticsTabFeature = [
  {
    title: 'Live Experience Analytics',
    desc: 'Real-time dashboards tracking movement, interactions, dwell zones, and engagement patterns across immersive environments.',
    video: videoPath?.Analytics,
  },
  {
    title: 'Spatial Behavior Mapping',
    desc: 'Heatmaps for gaze, pathways, and object interactions that reveal user intent, workflow efficiency, and learning gaps.',
    video: videoPath?.BehaviourMapping,
  },
  {
    title: 'Performance & Outcome Tracking',
    desc: 'Measure task accuracy, completion rates, errors, and decision-making patterns to evaluate and improve training or product experiences.',
    video: videoPath?.PerformenceOutcomeTracking,
  },
];

export const spatialAiTabFeature = [
  {
    title: 'Prompt-Based Spatial Control',
    desc: 'Users can trigger actions, modify environments, spawn assets, or guide simulations using natural language—instantly transforming scenes through AI-driven commands.',
    video: videoPath?.PromptBasedControl,
  },
  {
    title: 'Automated Training & Scenarios',
    desc: 'AI dynamically builds training modules, hazard scenarios, product demos, and walkthroughs—reducing manual design time and enabling infinite variations.',
    video: videoPath?.AutomatedTraining,
  },
  {
    title: 'Agentic AI for Real-Time Assistance',
    desc: 'Autonomous, goal-driven AI agents observe user behavior, provide guidance, evaluate performance, and interact with the environment to support learning and decision-making.',
    video: videoPath?.AgenticAiRealtime
  },
];

export const spatialAiData = [
  {
    title: 'Generative Spatial Content Creation ',
    description:
      'AI creates 3D scenes, props, annotations, and instructional overlays based on user intent and environmental context.',
    img: imagePath?.spatialContantCreation,
  },
  {
    title: 'Adaptive Agent Behavior',
    description:
      'AI agents respond to user actions, system states, and spatial cues—giving feedback, demonstrating tasks, or executing goals autonomously.',
    img: imagePath?.adaptiveAgent,
  },
  {
    title: 'Real-Time Simulation Orchestration',
    description:
      'AI manages environment states, object behaviors, scoring logic, and difficulty levels, ensuring personalized and evolving training experiences.',
    img: imagePath?.realTimeSimulation,
  },
  {
    title: 'Multi-Modal Understanding (Voice, Gesture, Text)',
    description:
      'Users interact naturally through voice commands, hand gestures, or text prompts—AI interprets multimodal signals to drive spatial actions.',
    img: imagePath?.multiModolUnderstanding,
  },
  {
    title: 'Predictive Insights & Proactive Support',
    description:
      'AI anticipates user needs, suggests next steps, detects errors, and recommends improvements during training or product interactions.',
    img: imagePath?.predictiveInsightSupport,
  },
  {
    title: 'State Persistence & Continuous Learning',
    description:
      'AI agents retain context across sessions, learning from previous interactions to deliver more accurate guidance and adaptive behavior over time.',
    img: imagePath?.statePersistenceLearning,
  },
];
